import axios from "axios";

const urlPath = "propertie";

export const nuevoCentroTrabajo = async (nif, data) => {

  try {
    const response = await axios.post(`${urlPath}/${nif}/workcenter`, data);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const deleteCentroTrabajo = async (id) => {
  try {
    const response = await axios.delete(`${urlPath}/workcenter/${id}`);

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const listCentroTrabajo = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/workcenter/list`, data.filtros, {
      params: data.params,
    });

    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};
